import { http } from '@/core/http/HttpFetch';
import { Injectable } from '@/core/di/Injectable';
import { localStorageModule } from '@/core/config/ConfigurationServer';
import { StockRepository } from '@/wms/domain/stock/StockRepository';
import { Stock } from '@/wms/domain/stock/Stock';

@Injectable()
export class StockServices implements StockRepository {
  private readonly API_BASE_URI: string = localStorageModule().transactions.host.API_BASE_URI;
  private readonly API_QUERY_STOCK: string =
    this.API_BASE_URI + localStorageModule().transactions.routes.API_QUERY_STOCK;
  private readonly API_STOCK_MOVES: string =
    this.API_BASE_URI + localStorageModule().transactions.routes.API_STOCK_MOVES;
  private readonly API_REFERENCE_FIND_STOCK: string =
    this.API_BASE_URI + localStorageModule().transactions.routes.API_STOCK;

  async findAll(): Promise<Stock[]> {
    try {
      return await http.get<Stock[]>(this.API_QUERY_STOCK);
    } catch (error) {
      throw new Error(`${error}`);
    }
  }

  async findStockMovements(payload: any): Promise<any[]> {
    return await http.get<any[]>(
      `${this.API_STOCK_MOVES}?fMonth=${payload.fMonth}&iMonth=${payload.iMonth}&sku=${payload.sku}&storeId=${payload.store}&year=${payload.year}`
    );
  }

  async findReferenceStock(payload: any): Promise<any[]> {
    return await http.get<any[]>(`${this.API_REFERENCE_FIND_STOCK}?sku=${payload.reference}&iMonth=${payload.iMonth}`);
  }
}
